<div class="d-flex" [title]="meta.info">
  <button class="btn d-flex justify-content-center align-items-center m-0" [class]="btnClass" [type]="type" [disabled]="disabled" [title]="meta.info">
    <span [ngSwitch]="showSpinner">
      <i *ngSwitchCase="true" class="spinner__icon spinner__icon--medium"></i>
      <i *ngSwitchDefault class="emp-icon" [class]="icon"></i>
    </span>
  </button>
</div>
